import I18N_STRINGS from 'Jsx/CheckoutV4/i18n/language';

import validateCPF from './validateCPF';

export const getBrasilIdentityDocument = (
  inputEvent: React.ChangeEvent<HTMLInputElement>,
): {
  identityDocument: string;
  isIdentityDocumentValid: boolean;
  identityDocumentErrorMessage: string;
  identityDocumentDigits: number;
} => {
  const { defaultValue, value } = inputEvent.target;
  const identityDocumentDigits = 14;
  let identityDocument = value.replace(/[a-zA-Z]|\s/g, '');

  const docFormatCPF = /^\d{3}[.]\d{3}[.]\d{3}[-]\d{2}$/;

  if (defaultValue.length < identityDocument.length) {
    identityDocument = identityDocument.replace(
      /^(\d{3})(\d{3})(\d{3})(\d{2})$/g,
      (_, p1, p2, p3, p4) => `${p1}.${p2}.${p3}-${p4}`,
    );
    if (identityDocument.length === 3 || identityDocument.length === 7) {
      identityDocument = `${identityDocument}.`;
    }
    if (identityDocument.length === 11) {
      identityDocument = `${identityDocument}-`;
    }
  }
  // CNPJ 01.637.050/0001-47
  // const docFormatCNPJ = /^\d{2}[.]\d{3}[.]\d{3}[/]\d{4}[-]\d{2}$/;
  const isFormatDocumentValid = docFormatCPF.test(identityDocument);

  const isIdentityDocumentValid =
    isFormatDocumentValid && validateCPF(identityDocument.replace(/\.|-/g, ''));
  let identityDocumentErrorMessage = '';

  if (isFormatDocumentValid && !isIdentityDocumentValid) {
    identityDocumentErrorMessage = I18N_STRINGS.INVALID_IDENTITY_DOCUMENT;
  }

  return {
    identityDocument,
    isIdentityDocumentValid,
    identityDocumentErrorMessage,
    identityDocumentDigits,
  };
};

export const getArgentinaIdentityDocument = (
  inputEvent: React.ChangeEvent<HTMLInputElement>,
): {
  identityDocument: string;
  isIdentityDocumentValid: boolean;
  identityDocumentErrorMessage: string;
  identityDocumentDigits: number;
} => {
  const { value } = inputEvent.target;
  const identityDocument = value.replace(/[a-zA-Z]|\s/g, '');
  const docFormat = /^\d{7,8}$/;
  const isFormatDocumentValid = docFormat.test(identityDocument);
  const isIdentityDocumentValid = isFormatDocumentValid;
  const identityDocumentDigits = 7;

  return {
    identityDocument,
    isIdentityDocumentValid,
    identityDocumentErrorMessage: !isIdentityDocumentValid
      ? I18N_STRINGS.INVALID_IDENTITY_DOCUMENT
      : '',
    identityDocumentDigits,
  };
};

export const getColombiaIdentityDocument = (
  inputEvent: React.ChangeEvent<HTMLInputElement>,
  documentType?: string,
): {
  identityDocument: string;
  isIdentityDocumentValid: boolean;
  identityDocumentErrorMessage: string;
  identityDocumentDigits: number;
} => {
  const { value } = inputEvent.target;
  const cedulaDigits = 11;
  const nitDigigts = 10;
  const identityDocument = value.replace(/[^\d]/g, '');
  const docFormat = documentType === 'CE' ? /^\d{6,11}$/ : /^\d{6,10}$/;
  const isFormatDocumentValid = docFormat.test(identityDocument);
  const isIdentityDocumentValid = isFormatDocumentValid;
  const identityDocumentDigits =
    documentType === 'CE' ? cedulaDigits : nitDigigts;

  return {
    identityDocument,
    isIdentityDocumentValid,
    identityDocumentErrorMessage: '',
    identityDocumentDigits,
  };
};
